import React from "react";
import {
  Container,
  Button,
} from "@material-ui/core";
import ScoreSlider from "hearing/assets/digits/score-slider";
import { P1, P2, P3 } from 'assets/fonts';


class Questions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      questions: ["How difficult did you find this block? Please make a mark on the line below.",
        "How much effort did it take for you to complete this block? Please make a mark on the line below."],
      hearing: {},
    };
  }

  validateHearing = () => {
    const { questions, hearing } = this.state;
    if (Object.keys(hearing).length !== questions.length) return false;
    return true;
  };

  handleSlider = (index, value) => {
    const { hearing, questions } = this.state;
    this.setState(() => {
      hearing[questions[index]] = value;
      return { hearing };
    });
  };

  renderButton = () => {
    const { questions, hearing } = this.state;
    if (questions.length === 0) {
      return null;
    } else if (this.validateHearing()) {
      return (
        <Button
          variant="contained"
          size="large"
          onClick={() => this.props.handleClick(hearing)}
          style={{
            color: "white", backgroundColor: "#107896",
            width: 200,
            marginBottom: 10,
          }}
        >
          Submit
        </Button>
      );
    } else {
      return (
        <div>
          <Button
            variant="contained"
            size="large"
            style={{
              width: 200,
              marginBottom: 10,
              color: "white", backgroundColor: "#107896"
            }}
            disabled={true}
          >
            Submit
          </Button>
          <P3>You cannot progress to the next step because you have not completed the questions.</P3>
        </div>
      );
    }
  };

  render() {
    const { hearing, questions } = this.state;
    return (
      <Container>
        <div
          style={{
            position: "relative",
            marginTop: "5%",
            marginBottom: "5%",
            marginLeft: "10%",
            marginRight: "10%",
          }}
        >
          <br />
          <div style={{ marginTop: 10 }}>
            <P2>{questions[0]}</P2>
            {hearing[questions[0]] &&
              hearing[questions[0]].wellness ? null : (
              <P3 className="text-danger">* must provide value</P3>
            )}
            <div className="row">
              <P3 style={{ marginTop: 10, marginLeft: 15 }}>
                Really Hard
              </P3>
              <P3 style={{ marginTop: 10, marginLeft: "32%" }}>
                Really Easy
              </P3>
            </div>
            <ScoreSlider
              handleScore={(value) => this.handleSlider(0, value)}
              style={{ marginLeft: "30%" }}
            />
          </div>
          <div style={{ marginTop: 10 }}>
            <P2>{questions[1]}</P2>
            {hearing[questions[1]] &&
              hearing[questions[1]].wellness ? null : (
              <P3 className="text-danger">* must provide value</P3>
            )}
            <div className="row">
              <P3 style={{ marginTop: 10, marginLeft: 15 }}>
                Minimal
              </P3>
              <P3 style={{ marginTop: 10, marginLeft: "35%" }}>
                Maximum
              </P3>
            </div>
            <ScoreSlider
              handleScore={(value) => this.handleSlider(1, value)}
              style={{ marginLeft: "30%" }}
            />
          </div>
          <br />
          {this.renderButton()}
        </div>
      </Container>
    );
  }
}

export default Questions;
